import FinancesHelpers from "../../utils/finances_helpers.coffee"
import BuildSteps from "../../utils/build_steps.coffee"
import translations from "../../translations"
import * as I18n from "../../services/i18n"
import StepProgressChart from "./charts/step_progress_chart.js"

$(document).on 'turbolinks:load', ->
  if $('.steps-progresscontainer').length > 0
    StepProgressChart.render()
